module.exports = __webpack_public_path__ + "img/wave-top.1ad0c6c5.png";